import { render, staticRenderFns } from "./propostaExterna.vue?vue&type=template&id=220ddf8f"
import script from "./propostaExterna.vue?vue&type=script&lang=js"
export * from "./propostaExterna.vue?vue&type=script&lang=js"
import style0 from "./propostaExterna.vue?vue&type=style&index=0&id=220ddf8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports